import React, { useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Sector } from 'recharts';

export default function DutySlipPieChart({
  invoiced = 0,
  notInvoiced = 0
}) {
  const [activeIndex, setActiveIndex] = useState(0);

  const currentInvoiced = Number(invoiced) || 0;
  const currentNotInvoiced = Number(notInvoiced) || 0;
  const total = currentInvoiced + currentNotInvoiced;
  const invoicedPct = total > 0 ? Math.round((currentInvoiced / total) * 100) : 0;

  const data = total === 0
    ? [
        { name: 'Invoiced', value: 0, color: '#008b8b' },
        { name: 'Not Invoiced', value: 0, color: '#b91c1c' }
      ]
    : [
        { name: 'Invoiced', value: currentInvoiced, color: '#008b8b' },
        { name: 'Not Invoiced', value: currentNotInvoiced, color: '#b91c1c' }
      ];

  const renderActiveShape = (props) => {
    const { cx, cy, innerRadius, outerRadius, startAngle, endAngle, fill } = props;
    return (
      <g style={{ outline: 'none' }}>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius - 2}
          outerRadius={outerRadius + 4}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
          style={{ outline: 'none' }}
        />
      </g>
    );
  };

  const currentItem = data[activeIndex] || data[0];

  return (
    <div className="dash-card p-2">
      <style>{`
        .recharts-wrapper,
        .recharts-surface,
        .recharts-pie-sector,
        .recharts-sector,
        .recharts-layer,
        svg:focus,
        path:focus,
        g:focus {
          outline: none !important;
          box-shadow: none !important;
          -webkit-tap-highlight-color: transparent;
        }
      `}</style>
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-1 px-1">
        <h6 className="m-0 fw-bold" style={{ fontSize: '12.5px', color: '#0f172a' }}>
          Duty Slip Status
        </h6>
        <span
          className="badge"
          style={{
            fontSize: '10px',
            fontWeight: '600',
            backgroundColor: '#f0fdf4',
            color: '#15803d',
            border: '1px solid #bbf7d0',
            padding: '2px 7px',
            borderRadius: '4px'
          }}
        >
          {invoicedPct}% Invoiced
        </span>
      </div>
      <div className="dash-card-body d-flex flex-column align-items-center justify-content-center position-relative pt-0 pb-1">
        <div style={{ width: '100%', height: 160, position: 'relative' }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart style={{ outline: 'none' }}>
              <Pie
                data={[{ value: 1 }]}
                cx="50%"
                cy="50%"
                innerRadius={46}
                outerRadius={47}
                fill="#e2e8f0"
                stroke="none"
                dataKey="value"
                isAnimationActive={false}
                style={{ outline: 'none' }}
              />
              <Pie
                activeIndex={total > 0 ? activeIndex : undefined}
                activeShape={renderActiveShape}
                data={total > 0 ? data : [{ name: 'No Data', value: 1, color: '#e2e8f0' }]}
                cx="50%"
                cy="50%"
                innerRadius={49}
                outerRadius={65}
                startAngle={90}
                endAngle={-270}
                dataKey="value"
                stroke="none"
                style={{ outline: 'none' }}
                tabIndex={-1}
                onMouseEnter={(_, index) => total > 0 && setActiveIndex(index)}
                onClick={(_, index) => total > 0 && setActiveIndex(index)}
              >
                {total > 0
                  ? data.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={entry.color}
                        tabIndex={-1}
                        style={{ cursor: 'pointer', transition: 'all 0.3s ease', outline: 'none' }}
                      />
                    ))
                  : <Cell fill="#cbd5e1" tabIndex={-1} />
                }
              </Pie>
            </PieChart>
          </ResponsiveContainer>

          <div
            className="position-absolute d-flex flex-column align-items-center justify-content-center"
            style={{
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              pointerEvents: 'none'
            }}
          >
            <span style={{ fontSize: '20px', fontWeight: '800', color: currentItem.color, lineHeight: '1.1' }}>
              {currentItem.value}
            </span>
            <span style={{ fontSize: '10.5px', color: '#718096', fontWeight: '500' }}>
              {currentItem.name}
            </span>
          </div>
        </div>

        <div className="d-flex gap-3 justify-content-center mt-1" style={{ fontSize: 9.5 }}>
          <div
            className="d-flex align-items-center gap-1"
            style={{ cursor: 'pointer', opacity: activeIndex === 0 ? 1 : 0.6 }}
            onMouseEnter={() => setActiveIndex(0)}
            onClick={() => setActiveIndex(0)}
          >
            <span style={{ width: 8, height: 8, background: '#008b8b', borderRadius: 2, display: 'inline-block' }}></span>
            <span>Invoiced <b>{currentInvoiced}</b></span>
          </div>
          <div
            className="d-flex align-items-center gap-1"
            style={{ cursor: 'pointer', opacity: activeIndex === 1 ? 1 : 0.6 }}
            onMouseEnter={() => setActiveIndex(1)}
            onClick={() => setActiveIndex(1)}
          >
            <span style={{ width: 8, height: 8, background: '#b91c1c', borderRadius: 2, display: 'inline-block' }}></span>
            <span>Not Invoiced <b>{currentNotInvoiced}</b></span>
          </div>
        </div>
      </div>
    </div>
  );
}